import * as Yup from "yup";

import {
    phoneRegex,
    zipRegex,
    cityRegEx,
    dateCantBeInFuture
} from "./validationFunctions";

export const repInfoValidations = (formType) => {

    if (true && formType.includes('Representative')) {
        return Yup.object().shape({

            RepFName: Yup.string().required(
                () =>
                    'Please provide a first name'
            ),
            RepLName: Yup.string().required(
                () =>
                    'Please provide a last name'
            ),
            RepPhone: Yup.string()
                .required(
                    () =>
                        'Please provide a phone number'
                )
                .matches(
                    phoneRegex,
                    'Please enter phone number in a valid format'
                ),
            Rep_Phone_Conform: Yup.string()
                .required(
                    () =>
                        "Please confirm your phone number"
                )
                .oneOf([Yup.ref('RepPhone'), '555'], 'Phone numbers must match'),
            RepEmail: Yup.string()
                .required(
                    () =>
                        'Please provide an email address'
                )
                .email(
                    'Please provide a valid email address'
                )
                .max(
                    50,
                    "Email address too long"
                ),
            Rep_Email_Conform: Yup.string()
                .required(
                    () =>
                        "Please confirm your email address"
                )                
                .test(
                    'email-match',
                    'Email addresses must match',
                    function (value) {
                        const { RepEmail } = this.parent; // Get the value of the RepEmail field
                        if (!RepEmail || !value) {
                            // If either field is empty, consider them a match
                            return true;
                        }
                        // Compare lowercase versions of the email addresses
                        return value.toLowerCase() === RepEmail.toLowerCase();
                    }
                ),
            RepAddress1: Yup.string()
                .required(
                    () =>
                        'Please provide an address'
                )
                .max(
                    50,
                    "Address too long"
                ),
            RepAddress2: Yup.string()
                .max(
                    50,
                    'Address too long'
                ),
            RepCity: Yup.string()
                .required(
                    () =>
                        'Please provide a city'
                )
                .matches(cityRegEx, 'City must contain only letters')
                .max(
                    30,
                    "City name too long"
                ),
            RepState: Yup.string()
                .required(
                    () =>
                        'Please provide a state'
                    
                )
                .matches(/^[A-Za-z]{2}$/, 'State must contain only letters')
                .max(
                    2,
                    'State value too long'
                ),
            RepMName: Yup.string()
                .max(
                    1,
                    "Middle initial too long"
                ),
            rrelationship: Yup.string()
                .required(
                    () =>
                        'Please specify your relationship to the patient'
                ),

            RepZip: Yup.string()
                .required(
                    () =>
                        'Please provide a zip code'
                )
                .matches(
                    zipRegex,
                    "Please provide a valid zip code"
                )
        });
    } else { return Yup.object().shape(); }
};



